import { RatenkreditGeschaeftskreditUndSonstigeVerbindlichkeit } from './RatenkreditGeschaeftskreditUndSonstigeVerbindlichkeit';

// NOTE: this schema does not represent the loan inside the real estates, but one of the liabilities of the household
export const Immobiliendarlehen = RatenkreditGeschaeftskreditUndSonstigeVerbindlichkeit;
